import { FunctionComponent } from "react";
import { Container } from "../Containers";
import { ColorClassNames } from "../Colors";

// export type ErrorMessageProps = React.FC;
interface ErrorMessageProps {
  children?: string | JSX.Element;
  noPaddingTop?: boolean;
}

/** A standardized form error component to render when an invalid form is submitted */
const ErrorMessage: FunctionComponent<ErrorMessageProps> = (props: ErrorMessageProps) => {
  /**
   * Transforms the component's children to be wrapped in a <p> tag if a string is passed, otherwise returns the children
   * @param {string | any} children - the react component's children. Uses any type as a catch all for JSX expression.
   */
  function formatChildren(children: "string" | any): JSX.Element {
    if (typeof children === "string") {
      return <p>{children}</p>;
    }
    return children;
  }

  // Do not display if there is no error
  if (!props.children) return null;

  return (
    <Container paddingTop={props.noPaddingTop ? 0 : 30} className="center-on-desktop" justifyContent="center">
      {/* data-error property is necessary so that the window scrolls to the error */}
      <span className={`medium ${ColorClassNames.cherry}`} data-error="true">
        {formatChildren(props.children)}
      </span>
    </Container>
  );
};

export default ErrorMessage;
